<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">倉庫ユーザーログイン</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
        <div class="container">
          <h5 class="mb-3"></h5>
          <div class="modal-dialog modal-md">
            <h4>倉庫ユーザーログイン</h4>
            <div class="modal-content">
              <div class="modal-body">
                <form class="needs-validation">
                  <h6 class="font-weight-bold">メールアドレス</h6>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control mb-3"
                    required>
                  <h6 class="font-weight-bold">パスワード</h6>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control mb-3"
                    required>
                  <div class="invalid-feedback">
                    メールアドレスとパスワードは必須です。
                  </div>
                </form>
              </div>
              <div class="modal-footer justify-content-between">
                <div>
                  <a class="btn btn-link decoration-underline" href="/warehouse-password-reset">パスワードをお忘れの場合</a>
                </div>
                <button type="button" class="btn btn-primary" v-on:click="beforeLogin">ログイン</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'WarehouseUserLogin',
  data () {
    return {
      email: '',
      password: '',
      isLoading: false
    }
  },
  components: {
    VueElementLoading
  },
  methods: {
    beforeLogin: function () {
      var self = this

      var forms = document.getElementsByClassName('needs-validation')
      Array.prototype.filter.call(forms, function (form) {
        if (form.checkValidity() === true) {
          self.login()
        }
        form.classList.add('was-validated')
      }, false)
    },
    login () {
      this.isLoading = true

      const params = {
        email: this.email,
        password: this.password
      }
      this.$http.post(this.$api_url.warehouse_user_login, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.$store.dispatch('WarehouseUser/loggedin', result.detail).then(() => {
            this.$router.push('/shipping-instructions')
          })
        } else {
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(e => {
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        console.log('account:login:catch(error): ', e)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
